module.exports = __webpack_public_path__ + "static/media/t565656.ca0ef862.png";